export const getFabricClient = () => window.__fabricClient || null;

export const isFabricContext = () => {
    return !!getFabricClient();
};

export const setFabricItemObjectId = (objectId) => {
    window.__fabricItemObjectId = objectId || null;
};

export const getFabricItemObjectId = () => window.__fabricItemObjectId || null;
